import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useLocation } from '@reach/router';

import { Office } from 'modules/offices';

import { AnalyticsEvent, getPlausibleClassName } from 'utils/analytics';

import * as UI from '../../../ui';
import Config from '../../../../config';
import { content } from './content';

import Details from './Details';

const {
    env: { IS_DE_LANG_ENV },
} = Config;

const { DynamicContainer, ContainerType, LocalizedLink } = UI;

const Address = ({ styles, rules, office, reference, contactLinkEventId }) => {
    const { pathname } = useLocation();
    return (
        <DynamicContainer
            extend={rules.extendContainer}
            isBerlin={office === Office.BERLIN}
            ref={reference}
            isFluid
            type={ContainerType.GRID}
        >
            <DynamicContainer extend={rules.extendAddressContainer} columns={8}>
                <Details content={content[office]} impressum={IS_DE_LANG_ENV ? content[office].impressum : undefined} />
            </DynamicContainer>
            <DynamicContainer columns={4} extend={rules.extendInquiryContainer}>
                <span className={styles.inquiryMessage}>
                    <FormattedMessage id={content[office].inquiry.message} />
                </span>
                <LocalizedLink
                    data-event-id={contactLinkEventId}
                    extend={rules.extendLink}
                    to={Config.routes['/contact']}
                >
                    <span
                        className={getPlausibleClassName(styles.inquiryCTA, AnalyticsEvent.CONTACT_TOP_CLICK, {
                            origin_path: pathname,
                        })}
                    >
                        <FormattedMessage id={content[office].inquiry.cta} />
                    </span>
                </LocalizedLink>
            </DynamicContainer>
        </DynamicContainer>
    );
};
Address.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape().isRequired,
    reference: PropTypes.shape(),
    office: PropTypes.oneOf(Object.values(Office)).isRequired,
    contactLinkEventId: PropTypes.string,
};

Address.defaultProps = {
    reference: PropTypes.null,
    contactLinkEventId: undefined,
};

export default Address;
